import style from './style.css';
import NonApprovedContainer from './nonApprovedContainer';
import KnowMoreButton from './knowMoreButton';
import { Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import OverlayScreen from '../overlayScreen';
import ntbAction from '../../../actions/ntbAction';
import { overLayHeights } from '../../../constants';
import OverlayNonApproved from '../overlayNonApproved';
import { tracker, PageLoadType } from '../../../tracking';

const NonApprovedUserCard = ({}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const handleCloseOverlay = () => {
    setShowOverlay(false);
  };
  const pageKey = 'pv_bic_context_card';
  const overlayHeight = overLayHeights.checkEligibleWidgetHeight;
  const overlaySizeClassName = 'overlay-wd-small';

  useEffect(() => {
    if (showOverlay) {
      return (document.body.style.overflowY = 'hidden');
    }
    document.body.style.overflowY = 'auto';
  }, [showOverlay]);

  useEffect(() => {
    return tracker.trackPageView(PageLoadType.DYNAMIC, pageKey, {
      status: 'nonApproved',
    });
  }, []);

  return (
    <Fragment>
      <div className={style.checkEligibilityContainer}>
        <div className={style.cardContainer}>
          <div className={style.cardWrapper}>
            <NonApprovedContainer />
            <div className={style.submitContainer}>
              <KnowMoreButton
                buttonId='na-know-more-button'
                pageKey={pageKey}
                buttonWrapperClass={style.submitButton}
                elementName='bic_know_more'
                buttonText={<Fragment>know more</Fragment>}
                buttonOnClick={() => {
                  setShowOverlay(true);
                }}
              />
            </div>
            <div className={style.startShoppingContainer}>
              <div className={style.startShoppingText}>
                Start shopping with Cardless EMI from your bank.
              </div>
              <div className={style.lenderLogo}>
                <div className={style.logoContainer}>
                  <img
                    src='https://iccdn.in/img/hdfc-logo-icon-v2.png'
                    className={style.lenderIcon}
                    alt='lender-logo'
                  />
                </div>
                <div className={style.logoContainer1}>
                  <img
                    src='https://iccdn.in/img/kotak-icon-v1.png'
                    className={style.lenderIcon}
                    alt='lender-logo'
                  />
                </div>
                <div className={style.subText}>+5</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showOverlay && (
        <OverlayScreen
          handleCloseOverlay={handleCloseOverlay}
          showOverlay={showOverlay}
          overlayHeight={overlayHeight}
          overlaySizeClassName={overlaySizeClassName}>
          <OverlayNonApproved
            handleCloseOverlay={handleCloseOverlay}
            ntbAction={ntbAction}
            shouldShowRetryOption={true}
          />
        </OverlayScreen>
      )}
    </Fragment>
  );
};

export default NonApprovedUserCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/nonApprovedUserCard/index.js